import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { IHttpRequestOptions } from '../../interfaces/http-request-option.interface';
import { HttpWrapperService } from '../http-wrapper.service';
import { IHowTo } from '../../interfaces/howto.interface';

@Injectable({
  providedIn: 'root',
})
export class HowToService {
  constructor(private readonly httpWrapperService: HttpWrapperService) {}

  getHowToWithActions(id: string): Observable<IHowTo> {
    const url = `HowToWithAction/${id}`;
    const options: IHttpRequestOptions = {
      url: url,
    };
    return this.httpWrapperService
      .getFromApiGateWay(options)
      .pipe(map((response: IHowTo) => response));
  }
}
